import { render, staticRenderFns } from "./kpPatchRoleDialog.vue?vue&type=template&id=78383a1e&scoped=true"
import script from "./kpPatchRoleDialog.vue?vue&type=script&lang=js"
export * from "./kpPatchRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./kpPatchRoleDialog.vue?vue&type=style&index=0&id=78383a1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78383a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78383a1e')) {
      api.createRecord('78383a1e', component.options)
    } else {
      api.reload('78383a1e', component.options)
    }
    module.hot.accept("./kpPatchRoleDialog.vue?vue&type=template&id=78383a1e&scoped=true", function () {
      api.rerender('78383a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/kpPatchRoleDialog.vue"
export default component.exports